import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateCompany: { company: { fromEmail: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.updateCompany.company.fromEmail,
  name: 'Company Email Alias',
})

const updateEmailAlias = ({ fromEmail, id }: { fromEmail: string | null; id: string }) => {
  return client.gql
    .mutate({ mutation, variables: { input: { fromEmail, id } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation updateCompanyEmailAlias($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      company {
        fromEmail
        id
      }
    }
  }
`

export default { updateEmailAlias }
